import { SET_REPORT_LIST, SET_CONNECTION_LIST, SET_SCHEDULE_LIST, SET_FTP_LIST } from '../types';

const INITIAL_STATE = {
    list: [],
    connection_strings: [],
    schedules: [],
    ftps: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_REPORT_LIST:
            return { ...state, list: action.payload }
        case SET_CONNECTION_LIST:
            return { ...state, connection_strings: action.payload }
        case SET_SCHEDULE_LIST:
            return { ...state, schedules: action.payload }
        case SET_FTP_LIST:
            return { ...state, ftps: action.payload }
        default:
            return state;
    }
}